module.exports = __webpack_public_path__ + "img/pet.9694d09e.svg";